import { render } from "./index.vue?vue&type=template&id=3ec0416c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3ec0416c&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/extra/VabIconSelector/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ec0416c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ec0416c', __exports__)) {
    console.log('reload')
    api.reload('3ec0416c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3ec0416c", () => {
    console.log('re-render')
    api.rerender('3ec0416c', render)
  })

}


export default __exports__